var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "news-card",
      class: {
        "news-card--pinned": _vm.item.pinned,
        "news-card--draft": !_vm.item.enable,
      },
    },
    [
      _c("header", { staticClass: "news-card__header" }, [
        _c("div", { staticClass: "news-card__titles" }, [
          _c(
            "div",
            { staticClass: "news-card__chips" },
            [
              !_vm.item.enable
                ? _c(
                    "v-chip",
                    {
                      attrs: {
                        "x-small": "",
                        color: "grey darken-1",
                        dark: "",
                      },
                    },
                    [_vm._v("Borrador")]
                  )
                : _vm._e(),
              _vm.item.pinned
                ? _c(
                    "v-chip",
                    { attrs: { "x-small": "", color: "primary", dark: "" } },
                    [_vm._v("Fijada")]
                  )
                : _vm._e(),
              _vm.item.is_new
                ? _c(
                    "v-chip",
                    { attrs: { "x-small": "", color: "orange", dark: "" } },
                    [_vm._v("Nueva")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("h2", { staticClass: "news-card__title" }, [
            _vm._v(_vm._s(_vm.item.title)),
          ]),
          _c("div", { staticClass: "news-card__meta" }, [
            _vm._v(_vm._s(_vm.meta)),
          ]),
        ]),
        _vm.can_update || _vm.can_delete
          ? _c(
              "div",
              { staticClass: "news-card__actions" },
              [
                _vm.can_update
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          small: "",
                          "aria-label": "Editar",
                          title: "Editar",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("edit", _vm.item)
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { small: "", color: "blue" } }, [
                          _vm._v("mdi-pencil-outline"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.can_delete
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          small: "",
                          "aria-label": "Eliminar",
                          title: "Eliminar",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("remove", _vm.item)
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { small: "", color: "red" } }, [
                          _vm._v("mdi-delete-outline"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.item.body
        ? _c("p", { staticClass: "news-card__body" }, [
            _vm._v(_vm._s(_vm.item.body)),
          ])
        : _vm._e(),
      _vm.youtube_url
        ? _c("div", { staticClass: "news-card__video" }, [
            _c("iframe", {
              attrs: {
                src: _vm.youtube_url,
                title: _vm.item.title,
                frameborder: "0",
                allow: "encrypted-media; picture-in-picture",
                allowfullscreen: "",
              },
            }),
          ])
        : _vm.item.link_url
        ? _c(
            "a",
            {
              staticClass: "news-card__link",
              attrs: {
                href: _vm.item.link_url,
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
            [
              _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                _vm._v("mdi-link-variant"),
              ]),
              _c("span", [
                _vm._v(_vm._s(_vm.item.link_text || _vm.item.link_url)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.item.attachments.length > 0
        ? _c(
            "div",
            { staticClass: "news-card__files" },
            [
              _c(
                "v-carousel",
                {
                  attrs: {
                    height: _vm.carousel_height,
                    "show-arrows": _vm.many_files,
                    continuous: _vm.many_files,
                    "hide-delimiters": "",
                  },
                  model: {
                    value: _vm.slide,
                    callback: function ($$v) {
                      _vm.slide = $$v
                    },
                    expression: "slide",
                  },
                },
                _vm._l(_vm.item.attachments, function (attachment, index) {
                  return _c(
                    "v-carousel-item",
                    { key: attachment.id },
                    [
                      _c("NewsAttachment", {
                        attrs: {
                          attachment: attachment,
                          active: _vm.slide == index,
                          height: _vm.carousel_height,
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
              _vm.many_files
                ? _c("span", { staticClass: "news-card__counter" }, [
                    _vm._v(
                      _vm._s(_vm.slide + 1) +
                        " / " +
                        _vm._s(_vm.item.attachments.length)
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.item.read_count != undefined && _vm.item.enable
        ? _c(
            "footer",
            { staticClass: "news-card__footer" },
            [
              _c("v-icon", { attrs: { "x-small": "" } }, [
                _vm._v("mdi-eye-outline"),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.item.read_count == 1
                      ? "1 lectura"
                      : _vm.item.read_count + " lecturas"
                  ) +
                  " "
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }